import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useBreakpointValue,
} from '@chakra-ui/react';
import { useUIStore } from '~/store/useUIStore';
import { LoginForm } from '~/components/auth/components/LoginForm';

export const LoginModal = () => {
  const modals = useUIStore((state) => state.modals);
  const setModals = useUIStore((state) => state.setModals);
  const isOpen = modals.loginOpen;
  const modalSize = useBreakpointValue({ base: 'full', md: 'md' });

  const onClose = () => {
    setModals({
      ...modals,
      loginOpen: false,
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      returnFocusOnClose={false}
      size={modalSize}
      isCentered
    >
      <ModalOverlay />
      <ModalContent
        my={{ base: '0', md: 'auto' }}
        mt={{ base: '4', md: 'auto' }}
      >
        <ModalCloseButton size="lg" />
        <LoginForm authHome={null} authProject={null} authAction={null} />
      </ModalContent>
    </Modal>
  );
};
